module.exports = __webpack_public_path__ + "static/media/Playblue.206c9aa1.svg";